import APIUtils from '@spothero/utils/api';

const VehicleAPI = {
    getVehicleInfos(search) {
        return APIUtils.get('vehicle-types', {
            search,
        });
    },

    /**
     * Gets complete vehicle info given vehicle attributes.
     *
     * @param {string} year vehicle year
     * @param {string} make vehicle make
     * @param {string} model vehicle model
     *
     * @return {object} complete vehicle info
     */
    getVehicleInfo(year, make, model) {
        return APIUtils.get(`vehicle-types/${year}/${make}/${model}`);
    },

    getMakes(year) {
        return APIUtils.get('vehicle-types/makes/', {
            year,
        });
    },

    getModels(make, year) {
        return APIUtils.get('vehicle-types/models/', {
            make,
            year,
        });
    },

    getYears() {
        return APIUtils.get('vehicle-types/years/');
    },

    getOversizedFee({make, model, year}) {
        return APIUtils.get('vehicle-types/oversized-fee/', {
            make,
            model,
            year,
        });
    },

    getColorOptions() {
        return APIUtils.get('vehicle-colors/');
    },
};

export default VehicleAPI;
